import { Button, IconButton, Stack, Typography } from '@mui/material';
import React from 'react';
import Iconify from '../../components/Iconify';

export default function HomeInfoBanniere({ onTop = false, onClose }) {
  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center" px={{ xs: 2, md: 10 }}>
      <Stack width={1} py={onTop ? 2 : 10} alignItems="center" spacing={3}>
        <Stack alignItems="center">
          <Typography variant="h3" fontSize={20}>
            Effectuez vos démarches en ligne
          </Typography>
        </Stack>
        <Button
          LinkComponent="a"
          href="https://services.apizf.tg/"
          target="_blank"
          variant="contained"
          endIcon={<Iconify icon="eva:diagonal-arrow-right-up-outline" />}
        >
          Démarrer une démarche en ligne
        </Button>
      </Stack>
      {onTop && (
        <Stack>
          <IconButton onClick={onClose} title="Fermer">
            <Iconify icon="eva:close-fill" />
          </IconButton>
        </Stack>
      )}
    </Stack>
  );
}
